(() => {
  const selector = '.comparison-module';
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const initialise = (module) => {
    if (module.dataset.comparisonReady === 'true') return;
    const lens = module.querySelector('.lens');
    const layer = module.querySelector('.after-layer');
    const divider = module.querySelector('.compare-divider');
    const handle = module.querySelector('.compare-handle');
    if (!lens || !layer || !divider) return;
    module.dataset.comparisonReady = 'true';
    const update = (clientX) => {
      const rect = lens.getBoundingClientRect();
      const percent = clamp(((clientX - rect.left) / rect.width) * 100, 0, 100);
      layer.style.width = percent + '%';
      divider.style.left = percent + '%';
      module.setAttribute('data-comparison-position', String(Math.round(percent)));
    };
    const updateFromEvent = (event) => update(event.clientX);
    lens.addEventListener('pointerdown', (event) => {
      event.preventDefault();
      lens.setPointerCapture?.(event.pointerId);
      updateFromEvent(event);
    });
    lens.addEventListener('pointermove', (event) => {
      if (event.buttons === 1 || event.pointerType === 'touch') updateFromEvent(event);
    });
    lens.addEventListener('pointerup', (event) => lens.releasePointerCapture?.(event.pointerId));
    lens.addEventListener('click', updateFromEvent);
    if (handle) {
      handle.type = 'button';
      handle.setAttribute('aria-label', 'Drag to compare water images');
      handle.tabIndex = 0;
      handle.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const current = Number(module.getAttribute('data-comparison-position') || 50);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? 100 : current + (event.key === 'ArrowLeft' ? -5 : 5);
        const rect = lens.getBoundingClientRect();
        update(rect.left + (clamp(next, 0, 100) / 100) * rect.width);
      });
    }
    update(lens.getBoundingClientRect().left + lens.getBoundingClientRect().width / 2);
  };
  const initialiseAll = (root = document) => root.querySelectorAll(selector).forEach(initialise);
  document.addEventListener('DOMContentLoaded', () => initialiseAll());
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  if (document.readyState !== 'loading') initialiseAll();
})();

(() => {
  const itemSelector = '.sil-faq-item';
  const initialise = (item, index) => {
    if (item.dataset.novyadoFaqReady === 'true') return;
    const question = item.querySelector('.sil-faq-question');
    const answer = item.querySelector('.sil-faq-answer');
    const plus = item.querySelector('.sil-faq-plus');
    if (!question || !answer) return;
    item.dataset.novyadoFaqReady = 'true';
    const id = answer.id || 'novyado-dental-faq-answer-' + index;
    answer.id = id;
    question.setAttribute('role', 'button');
    question.tabIndex = 0;
    question.setAttribute('aria-controls', id);
    const setOpen = (open) => {
      item.classList.toggle('is-open', open);
      question.setAttribute('aria-expanded', String(open));
      answer.setAttribute('aria-hidden', String(!open));
      answer.style.setProperty('display', open ? 'block' : 'none', 'important');
      if (plus) plus.textContent = open ? '−' : '+';
    };
    setOpen(false);
    const toggle = () => setOpen(question.getAttribute('aria-expanded') !== 'true');
    question.addEventListener('click', toggle);
    question.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      toggle();
    });
  };
  const initialiseAll = (root = document) => root.querySelectorAll(itemSelector).forEach(initialise);
  document.addEventListener('DOMContentLoaded', () => initialiseAll());
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  if (document.readyState !== 'loading') initialiseAll();
})();
